import Vue from 'vue';
import LoginBanner from 'components/LoginBanner.vue';
import { ValidationProvider, localize, extend, ValidationObserver } from "vee-validate";
import Site from "lib/Site";
import Popper from 'vue-popperjs';
const site = Site.getCurrentSite();
// Define custom validation messages
const dictionary = {
    en: {
        messages: {
            required: (fieldName) => `Please enter ${fieldName}`,
            // Add other validation messages if needed
        },
        names: {
            name: 'username or email',
            password: 'password'
        },
    },
    fr: {
        messages: {
            required: (fieldName) => `Veuillez entrer ${fieldName}`,
            // Add other validation messages if needed
        },
        names: {
            name: 'nom d\'utilisateur ou courriel',
            password: 'mot de passe'
        },
    }
};
// Localize VeeValidate with the custom dictionary
localize(dictionary);
// Use VeeValidate add rules
extend('required', {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});
// Create a new Vue instance for the login form
export default new Vue({
    el: '#app', // Make sure this targets the element wrapping your form
    data: {
        name: '',
        password: ''
    },
    created() {
        this.setLocale();
    },
    methods: {
        validateBeforeSubmit() {
            //console.log("Form Data Before Submission:", this.$refs.loginForm);
            this.submitForm();
        },
        submitForm() {
            const form = document.getElementById('loginForm');
            if (form instanceof HTMLFormElement) {
                form.submit();
            }
            else {
                console.error('Form not found or is not a form element');
            }
        },
        setLocale() {
            const lang = site.data.default_language_id === 2 ? 'fr' : 'en';
            localize(window.l.locale || lang);
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        'login-banner': LoginBanner,
        'v-popper': Popper,
    }
});
